<div class="h-full flex flex-col justify-between">
  <h2 mat-dialog-title class="!text-xl !font-bold" *ngIf="data.flag == 'INACTIVE'">Session Timeout</h2>
  <h2 class="!text-xl !font-bold mt-6 text-center" *ngIf="data.flag == 'SESSION_EXPIRE'">Your session is about to expire.</h2>
  <div class="flex flex-col justify-center !items-center !text-lg !font-bold !px-4 mt-2 !text-center">
    <span *ngIf="data.flag == 'INACTIVE'" class="!font-extrabold">You’ve been inactive.</span>
    <span class="!font-normal"> Please save your progress to avoid losing any unsaved changes.</span>
    <span class="pt-4">
      <strong class="!text-3xl font-extrabold">{{ minute + ':' + seconds }}</strong>
    </span>
  </div>
  <div class="flex justify-end pb-4 px-4">
    <button class="mdlz-btn" (click)="onStay()">{{ data.flag == 'INACTIVE' ? 'Stay Logged In' : 'Continue' }}</button>
  </div>
</div>
